// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___u-5G","rootNoMargin":"styles_rootNoMargin__2SaXb"};